import { Controller } from '@hotwired/stimulus';
import { show } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = ['comment'];

  connect() {
    const numberOfCommentsToDisplay = parseInt(
      window.getComputedStyle(this.element).top
    );
    this.hiddenComments.forEach((node, index) => {
      if (index >= numberOfCommentsToDisplay) return false;

      show(node);
    });
  }

  showAll() {
    this.hiddenComments.forEach((node) => show(node));
  }

  get hiddenComments() {
    return this.commentTargets.filter((node) => node.hidden === true);
  }
}
